"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MasterDetailContent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _useWindowSize2 = _interopRequireDefault(require("react-use/lib/useWindowSize"));
var _Main = _interopRequireDefault(require("../Layout/Main/Main"));
var _ModalView = require("../View/ModalView/ModalView");
var _breakpoints = require("../style/breakpoints");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type ThemeType } from '../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    container: {
      marginTop: '1rem'
    },
    root: (0, _defineProperty2.default)({
      position: 'relative',
      top: theme.variables.navHeight,
      height: function height(_ref) {
        var modalViewContext = _ref.modalViewContext;
        return modalViewContext ? "calc(100vh - ".concat(theme.functions.toRem(theme.variables.modalTop + theme.variables.modalMobilePadding + theme.variables.button), ")") : "calc(100vh - ".concat(theme.functions.toRem(theme.variables.navHeight), ")");
      }
    }, theme.breakpoints.desktop, {
      height: function height(_ref2) {
        var modalViewContext = _ref2.modalViewContext;
        return modalViewContext ? "calc(100vh - ".concat(theme.functions.toRem(theme.variables.modalTop + theme.variables.modalDesktopPadding + theme.variables.button), ")") : "calc(100vh - ".concat(theme.functions.toRem(theme.variables.navHeight), ")");
      }
    }),
    main: {
      position: 'relative',
      paddingTop: 0,
      paddingBottom: 0
    }
  };
});
/*:: type Props = {
  children: React.Node
};*/
var MasterDetailContent = exports.MasterDetailContent = function MasterDetailContent(_ref3 /*:: */) {
  var children = _ref3 /*:: */.children;
  var modalViewContext = React.useContext(_ModalView.ModalViewContext);
  var classes = useStyles({
    modalViewContext: modalViewContext
  });
  var _useWindowSize = (0, _useWindowSize2.default)(),
    width = _useWindowSize.width;
  var shouldRenderMasterDetailRoot = width > _breakpoints.devices.mobile.landscape;
  if (!shouldRenderMasterDetailRoot) {
    return /*#__PURE__*/React.createElement(_Main.default, null, /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, children));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    "data-testid": "master-detail-content-root"
  }, /*#__PURE__*/React.createElement(_Main.default, {
    className: classes.main
  }, children));
};
MasterDetailContent.displayName = 'MasterDetailContent';
var _default = exports.default = MasterDetailContent;
//# sourceMappingURL=MasterDetailContent.js.map